import api from '../../api'
import * as types from '../mutation_types'

// Initial state
const state = {
    activePoint: null,
    activePointAnswered: false,
    activePointAnswer: null,
    error: null,
    loading: false
};

// Getters
const getters = {
    point: (state) => state.activePoint
};

// Actions
const actions = {
    setActivePoint({commit}, point) {
        commit(types.SET_ACTIVE_POINT, point);
    },

    setAnswer({commit}, answer) {
        commit(types.SET_ACTIVE_POINT_ANSWER, answer);
    },

    async sendAnswer({commit, state, getters}) {
        commit(types.SEND_ANSWER_REQUEST);

        try {
            const response = await api.sendAnswer(getters.event._id, getters.team._id, getters.point.question._id, state.activePointAnswer);
            commit(types.SEND_ANSWER_SUCCESS, response);
        } catch (err) {
            commit(types.SEND_ANSWER_FAILURE, err);
        }
    },

    closePoint({commit}) {
        commit(types.CLOSE_ACTIVE_POINT);
    }
};

// Mutations
const mutations = {
    [types.SET_ACTIVE_POINT] (state, point) {
        state.activePoint = point;
        state.activePointAnswered = false;

        switch (point.question.answerType) {
            default:
                state.activePointAnswer = null;
                break;
            case 'multiple':
                state.activePointAnswer = [];
                break;
        }
    },

    [types.SET_ACTIVE_POINT_ANSWER] (state, answer) {
        state.activePointAnswer = answer;
    },

    [types.SEND_ANSWER_REQUEST] (state) {
        state.loading = true;
    },

    [types.SEND_ANSWER_SUCCESS] (state, response) {
        state.loading = false;
        state.activePointAnswered = response.answer;
    },

    [types.SEND_ANSWER_FAILURE] (state, error) {
        state.error = error;
        state.loading = false;
    },

    [types.CLOSE_ACTIVE_POINT] (state) {
        state.activePoint = null;
    },

    EXIT_GAME(state) {
        state.activePoint = null;
    }
};

// Export
export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/points.js